<template>
  <v-dialog v-model="modalAberto" transition="dialog-bottom-transition" max-width="900" persistent>
    <v-card class="mx-auto" :loading="carregando ? 'success' : null" :disabled="carregando">
      <v-toolbar flat outlined>
        <v-toolbar-title>
          <v-icon color="success" left size="x-large">
            mdi-bookmark-plus-outline
          </v-icon>
          {{ titulo }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fecharModal()">
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="12" sm="12">
            <v-data-table :loading="carregando ? 'success' : null"
              no-data-text="Nenhum(a) Atendimento não Finalizado encontrado(a)!"
              loading-text="Carregando os itens desta tabela! Aguarde..." :headers="colunasAtendimentosNaoFinalizados"
              :items-per-page="-1" hide-default-footer :items="atendimentos" class="elevation-0">
              <template v-slot:item.actions="{ item }">
                <v-row class="justify-center align-center">
                  <v-btn id="continuar" class="mx-2" x-small fab color="success" @click="continuarAtendimento(item.id)"
                    title="Continuar Atendimento">
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn id="descartar" class="mx-2" x-small fab color="error"
                    @click="excluirAtendimentoNaoFinalizado(item.id)" title="Descartar Atendimento">
                    <v-icon small>mdi-minus</v-icon>
                  </v-btn>
                </v-row>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import DateHelper from '@/helpers/DateHelper';
import { AlertaExclusaoQuestaoBooleano, AlertaSimplesErro, MensagemMixin } from '@/helpers/MensagemHelper';
import Agendamento from '@/models/agendamento/Agendamento';
import Atendimento from '@/models/atendimento/Atendimento';
import { SituacaoAgendamento } from '@/models/enums/EnumSituacaoAgendamento';
import Pacientes from '@/models/pacientes/Pacientes';
import { AgendamentoService } from '@/services/AgendamentoService';
import { AtendimentoService } from '@/services/AtendimentoService';
import { PacientesService } from '@/services/PacientesService';
import Vue from 'vue';

export default Vue.component('soi-modalAtendimentosNaoFinalizados', {
  name: 'soi-modalAtendimentosNaoFinalizados',
  props: {
    atendimentoId: {
      type: Number,
    },
  },
  data() {
    return {
      modalAberto: false,
      atendimentos: [],
      paciente: new Pacientes(),
      pacienteService: new PacientesService(),
      idPaciente: parseInt(this.$route.params.pacienteId, 10),
      atendimento: new Atendimento(),
      serviceAgendamento: new AgendamentoService(),
      atendimentoService: new AtendimentoService(),
      pacienteId: 0,
      carregando: false,
      agendamento: new Agendamento(),
      salaDeEspera: false,
      colunasAtendimentosNaoFinalizados: [
        {
          text: 'Data do Atendimento',
          align: 'center',
          value: 'dataAtendimento',
          filterable: true,
          sortable: true,
        },
        {
          text: 'Paciente',
          align: '',
          value: 'paciente.nomeCompleto',
          filterable: true,
        },
        {
          text: 'Médico',
          align: 'start',
          value: 'encaminhamento.usuario.nomeCompleto',
          filterable: true,
        },
        {
          text: 'Ações',
          align: 'center',
          value: 'actions',
        },
      ],
    };
  },
  computed: {
    titulo() {
      return 'Atendimento não finalizado';
    },
  },
  methods: {
    fecharModal() {
      this.$emit('fechandoModal');
      this.modalAberto = false;
    },
    async AgendamentoEmAndamento(): Promise<Boolean> {
      return this.serviceAgendamento.atualizaSituacaoAgendamento(this.agendamento.id, SituacaoAgendamento.EmAndamento).then(
        () => true,
        (err) => {
          AlertaSimplesErro('Não foi possível colocar em Andamento este agendamento!', err);
          return false;
        },
      );
    },
    async abrirModalAtendimentosNaoFinalizados(pacienteId: number) {
      this.pacienteId = pacienteId;
      await this.listarAtendimentosNaoFinalizados(pacienteId);

      if (this.atendimentos.length > 0) {
        this.modalAberto = true;
      } else {
        MensagemMixin(3000, 'info', 'Iniciando novo atendimento.');
        this.$router.push({ name: 'atendimentoForm', params: { pacienteId, agendamentoId: 0 } });
      }
    },
    async abrirModalAtendimentosNaoFinalizadosSalaDeEspera(agendamento: Agendamento, options?: { origemSalaDeEspera: boolean }) {
      this.salaDeEspera = true;
      this.agendamento = agendamento;
      this.pacienteId = agendamento.agendamentoConsulta.pacienteId;
      await this.listarAtendimentosNaoFinalizados(this.pacienteId);
      if (this.atendimentos.length > 0) {
        this.modalAberto = true;
      } else if (await this.AgendamentoEmAndamento()) {
        this.$router.push({
          name: 'atendimentoForm',
          params: {
            pacienteId: this.pacienteId,
            agendamentoId: agendamento.id,
          },
          query: {
            origemSalaDeEspera: options?.origemSalaDeEspera ? 'true' : 'false',
          },
        });
      }
    },
    async listarAtendimentosNaoFinalizados(pacienteId: number) {
      this.carregando = true;
      this.pacienteId = pacienteId;
      this.atendimentos = [];

      await this.atendimentoService.GetAllAtendimentosNaoFinalizados(pacienteId).then(
        (res) => {
          this.atendimentos = res.data;

          if (this.atendimentos.length === 0) {
            MensagemMixin(3000, 'info', 'Iniciando um novo atendimento.');
          }

          this.atendimentos.forEach((atendimento) => {
            // eslint-disable-next-line no-param-reassign
            atendimento.dataAtendimento = DateHelper.formataParaDiaMesAno(atendimento.dataAtendimento);
          });
        },
        (err) => { },
      );
      this.carregando = false;
    },
    async abrirModalAtendimentosNaoFinalizadosTodos() {
      this.carregando = true;
      this.atendimentos = [];

      try {
        const response = await this.atendimentoService.GetAllAtendimentosNaoFinalizadosTodos();
        this.atendimentos = response.data || [];
        this.atendimentos.forEach((atendimento) => {
          atendimento.dataAtendimento = DateHelper.formataParaDiaMesAno(atendimento.dataAtendimento);
          if (!atendimento.paciente || !atendimento.paciente.nomeCompleto) {
            AlertaSimplesErro('Dados do paciente ausentes para o atendimento:', atendimento.id);
          }
          if (!atendimento.encaminhamento || !atendimento.encaminhamento.usuario || !atendimento.encaminhamento.usuario.nomeCompleto) {
            AlertaSimplesErro('Dados do médico ausentes para o atendimento:', atendimento.id);
          }
        });

        if (this.$parent && this.$parent.$parent) {
          const header = this.$parent.$parent;
          if (header.temAtendimentosNaoFinalizados !== undefined) {
            header.temAtendimentosNaoFinalizados = this.atendimentos.length > 0;
          }
        }

        if (this.atendimentos.length > 0) {
          this.modalAberto = true;
        } else {
          MensagemMixin(3000, 'info', 'Não há atendimentos não finalizados.');
        }
      } catch (error) {
        AlertaSimplesErro('Erro ao carregar atendimentos não finalizados', error);
      } finally {
        this.carregando = false;
      }
    },
    async continuarAtendimento(atendimentoId: number) {
      // Encontrar o atendimento selecionado para obter o pacienteId
      const atendimentoSelecionado = this.atendimentos.find((a) => a.id === atendimentoId);
      if (!atendimentoSelecionado) {
        AlertaSimplesErro('Erro ao continuar atendimento', 'Atendimento não encontrado');
        return;
      }

      // Usar o pacienteId do atendimento se não estiver definido
      const pacienteIdParaUsar = this.pacienteId || atendimentoSelecionado.pacienteId;

      if (this.salaDeEspera) {
        if (await this.AgendamentoEmAndamento()) {
          this.$router.push({ name: 'atendimentoFormUpdate', params: { pacienteId: pacienteIdParaUsar, idAtendimento: atendimentoId } });
        }
      } else {
        this.$router.push({ name: 'atendimentoFormUpdate', params: { pacienteId: pacienteIdParaUsar, idAtendimento: atendimentoId } });
      }
    },
    async excluirAtendimentoNaoFinalizado(atendimentoId: number) {
      if (await AlertaExclusaoQuestaoBooleano()) {
        await this.atendimentoService.Delete(atendimentoId).then(
          (res) => {
            MensagemMixin(3000, 'success', 'Atendimento foi descartado com sucesso');
            this.$emit('AgendamentoEmAndamento');
            this.atualizarListaEStatus();
          },
          (err) => {
            AlertaSimplesErro('Aviso:', err);
          },
        );
      }
    },
    async verificarAtendimentosRestantes() {
      await this.atualizarListaEStatus();
    },
    async atualizarListaEStatus() {
      try {
        const response = await this.atendimentoService.GetAllAtendimentosNaoFinalizadosTodos();
        this.atendimentos = response.data || [];
        this.atendimentos.forEach((atendimento) => {
          atendimento.dataAtendimento = DateHelper.formataParaDiaMesAno(atendimento.dataAtendimento);
        });
        if (this.$parent && this.$parent.$parent) {
          const header = this.$parent.$parent;
          if (header.temAtendimentosNaoFinalizados !== undefined) {
            header.temAtendimentosNaoFinalizados = this.atendimentos.length > 0;
          }
        }
        if (this.atendimentos.length === 0) {
          this.modalAberto = false;
        }
      } catch (error) {
        AlertaSimplesErro('Erro ao atualizar lista e status:', error);
      }
    },
  },
});
</script>

<style>
.v-data-table thead th {
  padding: 25px !important;
}
</style>
